export default {
  productsection: 'Section de produit',
  productsections: 'Sections de produit',
  verbose_productsection: 'une section de produit',
};
